import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

import errorResponseHandler from '@/api/axios/errorResponseHandler';
import apiConfig from '@/config/url-api';
import { isSessionExpired } from '@/api/axios/handleUnauthorized';

const instance: AxiosInstance = axios.create({
  withCredentials: true,
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  responseType: 'json',
  headers: {
    Authorization: null,
  },
});

instance.interceptors.request.use(
  (config: any) => {
    // If session is already expired, abort any outgoing requests immediately so they don't hit the server
    if (isSessionExpired()) {
      const controller = new AbortController();
      controller.abort();
      config.signal = controller.signal;
      return Promise.reject(new axios.CanceledError('Session expired'));
    }

    const storedToken = localStorage.getItem(apiConfig.auth.storageTokenKeyName);

    if (storedToken) {
      config.headers['Authorization'] = 'Bearer ' + storedToken;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use((response: AxiosResponse) => response, errorResponseHandler);

export default instance;
